import axios from 'axios';
import {getData, postData, putData} from './redux_data';
import {
    GET_EMPRESAS,
    CREATE_EMPRESA,
    UPDATE_EMPRESA,
    DELETE_EMPRESA,
    OPEN_DIALOG,
} from '../constants/action_types';

import * as config from '../constants/configuration';

//mae_empresa actions:
export function getEmpresas() {
    return getData('empresas', GET_EMPRESAS);
};

export function createNewEmpresaDB(empresa) {

    return postData('empresas', CREATE_EMPRESA, empresa, undefined, undefined);
    
};

export function updateEmpresaDB(empresa, id) {
    
    return putData('empresas/', UPDATE_EMPRESA, empresa, id, 'Datos de la empresa guardados', undefined);

};

export function deleteEmpresaDB(id) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_EMPRESA, payload: id })
        let token = getState().oidc.user ? getState().oidc.user.access_token : "";
        axios.delete(config.API_URI() + 'empresas/' + id,
            {
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        ).then((response) => {
            dispatch({ type: DELETE_EMPRESA + "_SUCCESS", payload: response })
        }).catch((error) => {
            if (error.response.status === 409) {
                dispatch({
                    type: OPEN_DIALOG,
                    modalType: 'SimpleMessage',
                    modalProps: { message: error.response.data.message, exception: error.response.data.ex },
                    dialogid: 'error_delete_empresa_' + id
                });
            }
            else {
                dispatch({
                    type: OPEN_DIALOG,
                    modalType: 'SimpleMessage',
                    modalProps: { message: error.response.data.message, exception: error.response.data.ex },
                    dialogid: 'error_delete_empresa_' + id
                });
            }
        });
    };
};